/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconSocialTwitter = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M15.152 4.17a5.856 5.856 0 0 1-1.686.462 2.946 2.946 0 0 0 1.291-1.624 5.89 5.89 0 0 1-1.864.712 2.935 2.935 0 0 0-5.001 2.677 8.331 8.331 0 0 1-6.049-3.066 2.936 2.936 0 0 0 .907 3.918 2.918 2.918 0 0 1-1.329-.367v.037a2.938 2.938 0 0 0 2.354 2.878 2.937 2.937 0 0 1-1.325.05 2.94 2.94 0 0 0 2.742 2.038A5.89 5.89 0 0 1 .847 13.1a8.302 8.302 0 0 0 4.499 1.319c5.398 0 8.35-4.472 8.35-8.35 0-.127-.003-.254-.008-.38a5.94 5.94 0 0 0 1.464-1.519z"
    />
  </svg>
);

IconSocialTwitter.displayName = 'IconSocialTwitter';

IconSocialTwitter.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconSocialTwitter);
IconSocialTwitter.displayName = 'IconSocialTwitter';
